function buildAppContextValue(input) {
  const {
    route,
    params,
    navigate,
    currentUser,
    authToken,
    isSyncing,
    workspaceReady,
    activeCompanyId,
    setActiveCompanyId,
    activeCompany,
    companies,
    templates,
    users,
    approvals,
    batches,
    toast,
    toasts,
    persistentErrors,
    dismissPersistentError,
    clearPersistentErrors,
    debugEnabled,
    setDebugEnabled,
    debugBackendBaseUrl,
    debugBackendEndpoints,
    debugBackendConfig,
    debugApiSiengeByRoute,
    debugFrontendFilesByRoute,
    debugFrontendSharedFiles,
    companyPickerOpen,
    setCompanyPickerOpen,
    diffModalBatch,
    setDiffModalBatch,
    actions,
  } = input;

  return {
    route,
    params,
    navigate,
    currentUser,
    authToken,
    login: actions.login,
    logout: actions.logout,
    isSyncing,
    workspaceReady,
    activeCompanyId,
    setActiveCompanyId,
    activeCompany,
    companies,
    templates,
    users,
    approvals,
    syncFromApi: actions.syncFromApi,
    createCompany: actions.createCompany,
    updateCompany: actions.updateCompany,
    deleteCompany: actions.deleteCompany,
    testCompanySiengeConnection: actions.testCompanySiengeConnection,
    testSiengeCredentialsPreview: actions.testSiengeCredentialsPreview,
    fetchCompaniesSiengeLive: actions.fetchCompaniesSiengeLive,
    lookupCompanyCreditorInSienge: actions.lookupCompanyCreditorInSienge,
    fetchCompanyCreditors: actions.fetchCompanyCreditors,
    fetchCompanyCreditorsKpis: actions.fetchCompanyCreditorsKpis,
    fetchCreditorBankInformations: actions.fetchCreditorBankInformations,
    fetchCreditorAddressDetail: actions.fetchCreditorAddressDetail,
    fetchCreditorContactDetail: actions.fetchCreditorContactDetail,
    fetchCreditorPayments: actions.fetchCreditorPayments,
    syncCompanyCreditorsTotal: actions.syncCompanyCreditorsTotal,
    fetchCompanyCreditorsSyncTotalStatus: actions.fetchCompanyCreditorsSyncTotalStatus,
    fetchSiengeCreditorSyncSettings: actions.fetchSiengeCreditorSyncSettings,
    fetchSiengeFieldsOptions: actions.fetchSiengeFieldsOptions,
    fetchDebugSetting: actions.fetchDebugSetting,
    fetchDevelopmentResetPreview: actions.fetchDevelopmentResetPreview,
    fetchPaymentResetPreview: actions.fetchPaymentResetPreview,
    updateSiengeCreditorSyncSettings: actions.updateSiengeCreditorSyncSettings,
    resetSiengeCreditorSyncSettings: actions.resetSiengeCreditorSyncSettings,
    updateSiengeFieldsOptions: actions.updateSiengeFieldsOptions,
    resetSiengeFieldsOptions: actions.resetSiengeFieldsOptions,
    updateDebugSetting: actions.updateDebugSetting,
    resetDevelopmentSystem: actions.resetDevelopmentSystem,
    resetPayments: actions.resetPayments,
    deleteCreditor: actions.deleteCreditor,
    saveCreditorFromSienge: actions.saveCreditorFromSienge,
    syncCreditorPreferences: actions.syncCreditorPreferences,
    fetchCreditorPreferences: actions.fetchCreditorPreferences,
    setCreditorPreferences: actions.setCreditorPreferences,
    clearSyncQueue: actions.clearSyncQueue,
    fetchCreditorPrefSync: actions.fetchCreditorPrefSync,
    updateCreditorPrefSync: actions.updateCreditorPrefSync,
    fetchLoginLayout: actions.fetchLoginLayout,
    updateLoginLayout: actions.updateLoginLayout,
    fetchCompanySyncLogs: actions.fetchCompanySyncLogs,
    syncCompanyFieldsCompanies: actions.syncCompanyFieldsCompanies,
    syncCompanyFieldsCostCenters: actions.syncCompanyFieldsCostCenters,
    fetchCompanyFieldsCompanies: actions.fetchCompanyFieldsCompanies,
    fetchCompanyFieldsCostCenters: actions.fetchCompanyFieldsCostCenters,
    createUser: actions.createUser,
    updateUser: actions.updateUser,
    deactivateUser: actions.deactivateUser,
    saveTemplate: actions.saveTemplate,
    deleteTemplate: actions.deleteTemplate,
    batches,
    approveBatch: actions.approveBatch,
    resubmitApproval: actions.resubmitApproval,
    fetchArchivedBatches: actions.fetchArchivedBatches,
    rejectBatch: actions.rejectBatch,
    createBatchDraft: actions.createBatchDraft,
    deleteBatch: actions.deleteBatch,
    fetchLotDetail: actions.fetchLotDetail,
    fetchPaymentSyncLogs: actions.fetchPaymentSyncLogs,
    fetchPaymentQueueStats: actions.fetchPaymentQueueStats,
    togglePaymentPause: actions.togglePaymentPause,
    verifyLotPendencies: actions.verifyLotPendencies,
    updateLotPaymentData: actions.updateLotPaymentData,
    toast,
    toasts,
    persistentErrors,
    dismissPersistentError,
    clearPersistentErrors,
    debugEnabled,
    setDebugEnabled,
    debugBackendBaseUrl,
    debugBackendEndpoints,
    debugBackendConfig,
    debugApiSiengeByRoute,
    debugFrontendFilesByRoute,
    debugFrontendSharedFiles,
    companyPickerOpen,
    setCompanyPickerOpen,
    diffModalBatch,
    setDiffModalBatch,
  };
}

export { buildAppContextValue };
